(() => {
  function init(root) {
    if (root.dataset.comparisonReady) return;
    root.dataset.comparisonReady = 'true';
    const input = root.querySelector('input[type="range"]');
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    const seam = 643 / 1254 * 100;
    let interacted = false, visible = false, frame = 0, pointer = null, start = null;
    // The approved master divides at x=643; 50 on the control reproduces that framing.
    const map = value => value <= 50 ? value / 50 * seam : seam + (value - 50) / 50 * (100 - seam);
    const unmap = x => x <= seam ? x / seam * 50 : 50 + (x - seam) / (100 - seam) * 50;
    function draw(value) { root.style.setProperty('--mb-position', `${value}%`); }
    function update() {
      const value = Number(input.value);
      draw(map(value));
      input.setAttribute('aria-valuetext', value === 0 ? 'Full Nice' : value === 100 ? 'Full Naughty' : value === 50 ? 'Half Naughty, half Nice' : `${Math.round(value)} percent Naughty`);
    }
    function stop() {
      interacted = true;
      root.dataset.interacted = 'true';
      cancelAnimationFrame(frame);
      update();
    }
    function animate(now) {
      if (interacted || !visible || reduced.matches || !root.isConnected) return;
      if (start === null) start = now;
      const phase = (now - start) % 6000;
      // A four-pixel invitation; never a full-image sweep.
      const offset = phase < 1200 ? Math.sin(phase / 1200 * Math.PI * 2) * 4 / root.clientWidth * 100 : 0;
      draw(map(Number(input.value)) + offset);
      frame = requestAnimationFrame(animate);
    }
    const observer = new IntersectionObserver(entries => {
      visible = entries[0].isIntersecting;
      cancelAnimationFrame(frame);
      if (visible && !interacted && !reduced.matches) { start = null; frame = requestAnimationFrame(animate); }
      else update();
    }, {threshold:0.2});
    observer.observe(root);
    reduced.addEventListener('change', () => {
      cancelAnimationFrame(frame);
      update();
      if (visible && !interacted && !reduced.matches) { start = null; frame = requestAnimationFrame(animate); }
    });
    function move(event) {
      const rect = root.getBoundingClientRect();
      const x = Math.max(0, Math.min(100, (event.clientX - rect.left) / rect.width * 100));
      input.value = String(unmap(x));
      update();
    }
    root.addEventListener('pointerdown', event => {
      if (event.button !== 0) return;
      event.preventDefault();
      stop();
      input.focus({preventScroll:true});
      pointer = event.pointerId;
      root.setPointerCapture(pointer);
      move(event);
    });
    root.addEventListener('pointermove', event => { if (event.pointerId === pointer) move(event); });
    function release(event) {
      if (event.pointerId !== pointer) return;
      if (root.hasPointerCapture(pointer)) root.releasePointerCapture(pointer);
      pointer = null;
    }
    root.addEventListener('pointerup', release);
    root.addEventListener('pointercancel', release);
    input.addEventListener('focus', stop);
    input.addEventListener('keydown', stop);
    input.addEventListener('input', () => { stop(); update(); });
    update();
  }
  document.querySelectorAll('[data-mb-compare]').forEach(init);
  document.addEventListener('shopify:section:load', e => e.target.querySelectorAll('[data-mb-compare]').forEach(init));
})();
